import { IGetNewParams } from '@r1-frontend/api-domru/content-static/v2/news/dto/requestDto';

import { IRequest } from '@r1-frontend/shared/types/IRequest';

export const news = (providerId: number, queryParams?: IGetNewParams): IRequest => ({
    uri: `/api/v2/${providerId}/news`,
    method: 'GET',
    withProvider: true,
    queryParams,
});

export type { IBaseItem, ICategoryInfo, INewsResponse, IResponseItem, IResponseItemTag } from './dto/responseDto';
